import { VisuallyHidden } from '@react-aria/visually-hidden';
import { useIntl } from 'react-intl';

import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useAuth } from '@/context/auth/AuthProvider';
import { CalmAuthMethods } from '@/utils/privacyCookies';

import messages from './messages';
import { Icon, Wrapper } from './styles';
import { GoogleAuthButtonProps, GoogleButtonProps } from './types';

const GoogleButton = ({ buttonText, hideMessage = false, onClick }: GoogleButtonProps) => {
	const { formatMessage } = useIntl();
	const { authPrompt } = useAuthPrompt();

	const getButtonCta = () => {
		if (buttonText) {
			return buttonText;
		}

		return authPrompt === 'login' ? formatMessage(messages.signInCta) : formatMessage(messages.continueCta);
	};

	const buttonCta = getButtonCta();
	const bgColor = 'white';
	const textColor = 'black';
	const borderColor = 'gray3';

	return (
		<Wrapper
			backgroundColor={bgColor}
			contentAlignment="center"
			data-testid="google-button"
			onPress={onClick}
			role="link"
			$noPadding={hideMessage}
			textColor={textColor}
			borderColor={borderColor}
		>
			<Icon $noMargin={hideMessage} />
			{hideMessage ? <VisuallyHidden>{buttonCta}</VisuallyHidden> : buttonCta}
		</Wrapper>
	);
};

const BrowserGoogleAuthButton = (props: GoogleAuthButtonProps) => {
	const { buttonText, hideMessage, onAuthSuccess, marketingOptIn } = props;

	const { authenticate } = useAuth();

	const onClick = () => {
		authenticate({ authMethod: CalmAuthMethods.Google, marketingOptIn, onAuthSuccess });
	};

	return <GoogleButton buttonText={buttonText} hideMessage={hideMessage} onClick={onClick} />;
};

export default function GoogleAuthButton(props: GoogleAuthButtonProps) {
	return <BrowserGoogleAuthButton {...props} />;
}
